import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../_models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    public baseUrl="https://access.vaishyasabhamumbaivivah.com";
    //public baseUrl="https://matrimonial.dsmsolution.com";
    private key = "eyJjdCI6InJkZll2SDd0WGtvZVJ2Y3I3RTZSb1k5YmVSakt5OHY3d25YMkliZlhrbDFMeGxCcTBoYWZwdG9RUnBJcTBJU2hmZnRINjVqUjNNVlFQQ0R5Vks5Zk1BPT0iLCJpdiI6IjZhZTZlZjgyMDM2ZGZjZGQ2MmU2ODRlZjQ4MTNmNzMxIiwicyI6IjZjNGQ2NWM4YWQxOTdiNDgifQ==";
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {
        return this.http.post<any>(`${this.baseUrl}/login?string=${this.key}`, { username, password })
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }

                return user;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
}